export const debounce = <T extends (...args: any[]) => void>(func: T, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout>;

  return (...args: Parameters<T>): void => {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

export enum ValidateFieldTypes {
  EMAIL = 'EMAIL',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
}

export const validationSchemeMap = {
  [ValidateFieldTypes.EMAIL]: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  [ValidateFieldTypes.FIRST_NAME]: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
  [ValidateFieldTypes.LAST_NAME]: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
};

export const validateScheme = (value: string, fieldId: ValidateFieldTypes): boolean => {
  const scheme = new RegExp(validationSchemeMap[fieldId]);
  return scheme.test(value);
};
